export default {
  setNotifications(state, { data }) {
    state.notifications = data;
  },
};
